import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Preload icons used for sections as defined in etc/plugin_sections.yml
/* eslint-disable no-unused-vars */
import {
  faAlignLeft,
  faCode,
  faInfoCircle,
  faMapMarkerAlt,
  faTable,
  faUsers
} from '@fortawesome/pro-solid-svg-icons';
/* eslint-enable no-unused-vars */

import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';

export class WebsiteSection extends React.Component {
  static propTypes = {
    ...listItemPropTypes,

    index: PropTypes.number.isRequired,
    listName: PropTypes.string.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    section: PropTypes.shape({
      id: PropTypes.number.isRequired,
      icon: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      location: PropTypes.string.isRequired,
      sectionType: PropTypes.string.isRequired,
      customFieldSlug: PropTypes.string,
      title: PropTypes.string,
      content: PropTypes.text,
      buttonUrl: PropTypes.string,
      buttonText: PropTypes.string
    }).isRequired,
    targetGroup: PropTypes.string
  };

  deleteSection = () => {
    this.props.onDelete(this.props.section);
  };

  editSection = () => {
    this.props.onEdit(this.props.section);
  };

  render() {
    const listItemClass = classNames(
      "website-section",
      {
        dragging: this.props.isDragging,
        reorderable: !this.props.disabled
      }
    );
    const style = { opacity: this.props.isDragging ? 0 : 1 };
    return this.props.connectDragPreview(this.props.connectDropTarget(this.props.connectDragSource(
      <li className={listItemClass} style={style}>
        <div className="section-col section-icon text-center">
          <FontAwesomeIcon name="section-icon" icon={this.props.section.icon} className="text-primary" />
        </div>
        <div className="section-col section-label">
          <strong>{this.props.section.label}</strong>
        </div>
        <div className="section-col text-right">
          {this.renderActions()}
        </div>
      </li>
    )));
  }

  renderActions() {
    return (
      <div className="section-actions">
        <Button
          bsClass="btn btn-link btn-sm edit-section"
          disabled={this.props.disabled}
          name="edit-section"
          onClick={this.editSection}
        >
          Edit
        </Button>
        <Button
          bsClass="btn btn-link btn-sm text-danger delete-section"
          disabled={this.props.disabled}
          name="delete-section"
          onClick={this.deleteSection}
        >
          Delete
        </Button>
      </div>
    );
  }
}

export default reorderableListItem(WebsiteSection, 'websiteSection', {
  // dragSource
  canDrag: (props => !props.disabled),

  beginDrag(props) {
    return {
      id: props.section.id,
      index: props.index,
      listName: props.listName,
      targetGroup: props.targetGroup
    };
  }
});
